import { useQuery } from "@tanstack/react-query"
import { useTRPC } from "utils/trpc"

export const useProductsMeta = () => {
  const trpc = useTRPC()

  const { data, ...rest } = useQuery(
    trpc.products.getProducts.queryOptions(
      {},
      {
        // Store for 1 day
        staleTime: 1000 * 60 * 60 * 24,
      }
    )
  )

  return {
    data: data?.data,
    ...rest,
  }
}
